import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { PWAProvider } from './context/PWAContext';
import LoginPage from './pages/LoginPage';
import TechnicalIssuePage from './pages/TechnicalIssuePage';
import OrderPage from './pages/OrderPage';
import PrintOrderPage from './pages/PrintOrderPage';
import OrderStatusPage from './pages/OrderStatusPage';
import AdminPage from './pages/AdminPage';
import CustomerLoginPage from './pages/CustomerLoginPage';
import PublicCompanyRegistration from './features/auth/PublicCompanyRegistration';
import VerifyDocumentPage from './pages/VerifyDocumentPage';
import ProtectedRoute from './components/ProtectedRoute';
import { getSubdomain } from './utils/subdomainHelper';
import CustomerOrdersHistoryPage from './pages/CustomerOrdersHistoryPage';
import CustomerProfilePage from './pages/CustomerProfilePage';
import LandingPage from './pages/LandingPage';
import DeploymentAutoRefresh from './components/common/DeploymentAutoRefresh';

const RootRoute = () => {
  const isStandalone = typeof window !== 'undefined' && 
    (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true);

  if (isStandalone) {
    return <Navigate to="/admin" replace />;
  }

  return <LandingPage />;
};

const App = () => {
  const subdomain = getSubdomain();

  return (
    <AuthProvider>
      <PWAProvider>
        <Router>
          <DeploymentAutoRefresh />
          <Routes>
            {/* Conditional Root and Login Routes based on Subdomain */}
            {subdomain ? (
              <>
                <Route path="/login" element={<CustomerLoginPage />} />
                <Route path="/" element={<Navigate to="/login" replace />} />
              </>
            ) : (
              <>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/" element={<RootRoute />} />
              </>
            )}

            <Route path="/register" element={<PublicCompanyRegistration />} />
            <Route path="/error" element={<TechnicalIssuePage />} />
            <Route path="/shop" element={<OrderPage />} />
            {/* Redirect old /order URL to /shop */}
            <Route path="/order" element={<Navigate to="/shop" replace />} />
            <Route path="/order/login" element={<CustomerLoginPage />} />
            <Route path="/order/login/:supplierId" element={<CustomerLoginPage />} />
            <Route path="/status/orders" element={<CustomerOrdersHistoryPage />} />
            <Route path="/customer/profile" element={<CustomerProfilePage />} />
            <Route path="/status/:orderId" element={<OrderStatusPage />} />
            <Route path="/verify" element={<VerifyDocumentPage />} />
            <Route path="/verify/:docNo" element={<VerifyDocumentPage />} />
            <Route path="/print-order" element={<PrintOrderPage />} />

            {/* Protected Routes */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminPage />
                </ProtectedRoute>
              }
            />

            {/* Catch-all - Redirect to login */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </Router>
      </PWAProvider>
    </AuthProvider>
  );
};

export default App;